import React, { ReactNode } from 'react';

import Classes from './VerticalScrollList.module.scss';

type TProps = {
  children: ReactNode;
  className?: string;
};

const VerticalScrollListItem = ({ children, className }: TProps) => (
  <div className={`${Classes.listItem} ${className}`}>{children}</div>
);

export default VerticalScrollListItem;
